import { AxiosResponse } from "axios";
import BaseApi from "./BaseApi";
import AxiosService from "./Axios";
import TenantDevices from "../views/tenant-device/TenantDevices";

const BASE_URL = '/tenant-node';

class TenantDeviceApi {

    public async queryTenantDeviceViews(tenantId: string, search: string, pageNo: number, pageSize: number): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/tenant-node-view/query', { 
            tenantId: tenantId,
            search: search,
            pageNo: pageNo,
            pageSize: pageSize,
        });
    }

    public async getTenantDeviceViewByNodeSn(nodeSn: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/tenant-node-view/node-sn/' + nodeSn);
    }

    public async getAllTenantDeviceViews(): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/tenant-node-view/all');
    }


    public async addTenantDevice(tenantId: string, nodeSn: string): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/add', { tenantId, nodeSn });
    }

    public async addTenantDevices(tenantDevices: {tenantId: string, nodeSn: string}[]): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/add-batch', tenantDevices);
    }

    public async removeTenantDevice(tenantId: string, nodeSn: string): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/remove', { tenantId, nodeSn });
    }

    public async removeTenantDevices(tenantDevices: {tenantId: string, nodeSn: string}[]): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/remove-batch', tenantDevices);
    }

    public async invokeDeviceService(request: InvokeDeviceServiceRequest): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/service/invoke', request);
    }

    public async getInvokeDeviceResponse(id: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/service/response', {
            params: {
                id: id
            }
        });
    }
}

interface InvokeDeviceServiceRequest {
    sn: string,
    service: string,
    params: any,
    password?: string,
}

export default TenantDeviceApi;

